/**
 * Specification-step fieldnames.
 */
export enum SpecFieldNames {
  MIX_CODE = 'mixCode',
  MIX = 'mix',
  CONTRACT = 'contract',
  DELIVERY_TIME = 'deliveryTime',
  PURCHASE_ORDER = 'purchaseOrder',
  RECEIVING_PERSON = 'receivingPerson',
  PRODUCT_SELECTION = 'productSelect',
  PRODUCT_DISPLAY = 'productDisplay',
  PRODUCT_DESCRIPTION = 'productDesc',
  PRODUCT_COMMERCIAL_DESCRIPTION = 'commercialDesc',
  PRODUCT_CATALOG = 'productCatalog',
  QUANTITY = 'quantity',
  QUANTITY_REMAINS = 'quantityRemain',
  LOADS_REMAINS = 'loadsRemain',
  DATE = 'date',
  TIME = 'time',
  TIME_TO = 'time_to',
  SPACING_TIME = 'requestedDateTime',
  SPACING_LOADS = 'loadsSpacing',
  LOAD_SPACING = 'spacing',
  SUNDAY_HOLIDAY_DAY = 'nonworking_day',
  TIME_WINDOWS = 'deliveryTimeWindows',
  CONTRACT_ANTICIPATED_INVOICE = 'anticipatedInvoice',
  PURCHASE_ORDER_CHECKBOX = 'purchaseOrdersCheckBox',
  PURCHASE_ORDERS = 'multiplePurchaseOrder',
  PURCHASE_ORDERS_BUTTON = 'purchaseOrdersButton',
  PURCHASE_ORDER_INFO = 'purchaseOrdersInfo',
  PROGRAMMED_DATE = 'programmedDateTime',
  REQUESTED_DATE = 'requestedDateTime',
  UNIT_DESC = 'unitDesc',
  COUNTER_OFFERS = 'counterOffers',
  COUNTER_OFFERS_TO = 'counterOffersTo',
  COUNTER_OFFERS_DAY = 'counterOffersDay',
  ID = 'id',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
  AFTER_CUTOFF_INFO = 'afterCutoffInfo',
  /**
   * This is for display of (or typing in?) a contract ID.
   * @type {string}
   */
  CONTRACT_INFORMATIVE = 'contract',
  /**
   * For a drop-down menu of contracts, use this.
   * @type {string}
   */
  CONTRACT_SELECT = 'contractSelect',
  UNIT = 'unit',
  VALUE_ADDED = 'valueAdded',

  // Catalogs
  CLEAN_UP = 'kicker',
  SPREAD_BAR = 'SPRBAR',
  ASAP = 'ASAP',
  DUST_BAG = 'DUSTBAG',
  ADDITIONAL_SERVICES = 'additionalServices',
  PROJECT_PROFILES = 'projectProfiles',
  UNLOAD_TYPE = 'unloadType',
  PUMP = 'pumpCapacity',
  PIPE_QUANTITY = 'pipeQuantity',
  APPLICATION = 'element',
  APPLICATION_REQ = 'application',
  DISCHARGE_TIME = 'dischargeTime',
  SPACING = 'timePerLoad',
  SLUMP = 'slump',
  SLUMP_PRODUCT = 'slumpProduct',
  SLUMP_TYPE = 'slumpType',
  ADDITIONAL_PRODUCTS = 'additionalProduct',
  LOAD_SIZE = 'loadSize',
  ADJUSTMENT = 'adjustment',
  HOSES = 'hoses',
  PUMPABILITY = 'pumpability',
  COLOR_INFO = 'color',
  UNLOAD_TIME = 'unloadTime',
  PUMP_PRIMER_MIX = 'pumpPrimerProduct',
  PRIMER_QUANTITY = 'primerQuantity',
  PRIMER_SLUMP = 'primerSlump',
  PRIMER_ARRIVAL_BEFORE_DELIVERY = 'primerArrivalBeforeDelivery',
  PUMP_PRIMER_PRODUCT = 'pumpPrimerProduct',
  CLEANING_ON_SITE = 'cleaningOnSite',

  ADDITIONAL_INFO = 'additionalInfo',
  RECCURENCE = 'reccurence',
  PAYMENT_TERMS = 'paymentTerms',
  PAYMENT_TERMSDESC = 'paymentTermsDesc',
  PAYMENT_TYPECODE = 'productTypeCode',
  ORDER_ID = 'orderId',
  JOBSITE_CODE = 'jobsiteCode',
  PLANTS = 'plants',
  PLANT = 'plant',
  HAULER = 'hauler',
  FORMAT = 'format',
  DELIVERY_MODE = 'deliveryMode',
  VEHICLE = 'vehicle',
  POINT_OF_DELIVERY = 'pointOfDelivery',
  STATUS = 'status',

  // RETAIL::TODO: Move this file to common module for both specifications
  // Retail
  // ------------------------------

  // Prototype
  CATALOG = 'catalog',
  VALIDATE_DATE = 'validateDate',
  PROTOTYPE_ADD = 'add',
  STD_LOD_INFORMATIVE = 'stdLotInfo',

  CEMEXPUMP_REQUIRED_SIZE = 'cemexpumpRequiredSize',
  CEMEXPUMP_ALTERNATIVE_SIZE_TO_MAXIMUM = 'cemexpumpAlternativeSizeToMaximum',
  CEMEXPUMP_PIPE_LENGTH = 'cemexpumpPipeLength',
  CEMEXPUMP_PIPE_DIAMETER = 'cemexpumpPipeDiameter',
  CEMEXPUMP_COMMENTS = 'cemexpumpComments',
  CEMEXPUMP_POWER_LINE = 'cemexpumpPowerLine',
  CEMEXPUMP_FALL_PROTECTION = 'cemexpumpFallProtection',
  CEMEXPUMP_CLEANING_ON_SITE = 'cemexpumpCleaningOnSite',
  CEMEXPUMP_PRIMER_BY_CEMEX = 'cemexpumpPrimerByCemex',

  // RETAIL::TODO: Move this file to common module for both specifications

  // Recipe
  ITEM_SEQ_NUM = 'itemSeqNum',

  // RMS Online
  SCHEDULE_MOMENT = 'scheduleMoment',
  WAITING_LIST = 'waitingList',
  WAITING_LIST_2025_REDESIGN_ENABLED = 'waitingList2025RedesignEnabled',
  WAITING_LIST_MOMENT = 'waitingListMoment',
  PRODUCT_PUMP_INFORMATIVE = 'productPumpInformative',
  SPECIAL_INSTRUCTION = 'specialInstruction',
  DELIVERY_INSTRUCTIONS = 'deliveryInstruction',
  CONCRETE_MIN_QUANTITY_INFO = 'concreteMinQuantityInfo',
  SPECIAL_INSTRUCTION_INFORMATIVE = 'specialInstructionInfo',
  KICKER = 'kicker',
  MANEUVER = 'maneuver',

  // Boom pump (Bomba pluma)
  PUMP_LENGTH = 'pumpLength',

  // Linear meters
  LINEAR_METERS = 'linearMeters',

  // Recipe labels
  SAME_DAY_DELIVERY_MESSAGE = 'sameDayDeliveryMessage',
  MIN_WEIGHT_SURCHARGE_WARINING = 'minWeightSurchargeWarning',
  DUST_BAG_WARNING = 'dustBagWarning',
  UNAVAILABILITY_DISCLAIMER = 'unavailabilityDisclaimer',
  DELIVERY_TIME_EXTENDED = 'deliveryTimeExtended',
  BLACKOUT_DAY_DELIVERY_MESSAGE = 'blackoutDayDeliveryMessage',

  // Expiration Date
  ALERT_EXPIRATION_DATE = 'alertExpirationDate',
  TEMPERATURE_LABEL = 'temperatureLabel',
  TEMPERATURE_NONE_CONDITION = 'temperatureCondition',
  ICE_LABEL = 'iceLabel',
  // NITRO EXPERIENCE Temperature Management
  INFO_TEMPERATURE_MANAGEMENT = 'infoTemperatureManagement',
  TEMPERATURE_UNDER = 'temperatureUnder',
  TEMPERATURE_UNDER_DISABLED = 'temperatureUnderDisabled',
  SUMMER_SET = 'temperatureVSummerSet',
  SUMMER_SET_DISABLED = 'temperatureVSummerSetDisabled',
  DECLINE_TEMPERATURE_MANAGEMENT = 'declineTemperatureManagement',

  // ICE EXPERIENCE
  ICE_QUANTITY = 'iceQuantity',

  // Delivery Address View MAP
  DELIVERY_ADDRESS_VIEW_MAP = 'deliveryAddressViewMap',

  // VL4
  POINT_OF_DELIVERY_NAME = 'pointOfDeliveryName',
  ADDRESS = 'Address',
  ADDRESS2 = 'Address2',
  COPY_ADDRESS = 'CopyAddress',
  CITY = 'City',
  STATE = 'State',
  ZIP = 'Zip',
}

export interface AdditionalServicesFieldNames {
  DUSTBAG?: string;
  SPRBAR?: string;
  ASAP?: string;
}

export type SpecFieldNamesType =
  | SpecFieldNames.PRODUCT_SELECTION
  | SpecFieldNames.PRODUCT_CATALOG
  | SpecFieldNames.QUANTITY
  | SpecFieldNames.DATE
  | SpecFieldNames.TIME
  | SpecFieldNames.TIME_WINDOWS
  | SpecFieldNames.CONTRACT_ANTICIPATED_INVOICE
  | SpecFieldNames.CONTRACT_INFORMATIVE
  | SpecFieldNames.CONTRACT_SELECT
  | SpecFieldNames.UNIT
  | SpecFieldNames.CLEAN_UP
  | SpecFieldNames.ADDITIONAL_SERVICES
  | SpecFieldNames.PROJECT_PROFILES
  | SpecFieldNames.UNLOAD_TYPE
  | SpecFieldNames.PUMP
  | SpecFieldNames.PIPE_QUANTITY
  | SpecFieldNames.HOSES
  | SpecFieldNames.ADJUSTMENT
  | SpecFieldNames.APPLICATION
  | SpecFieldNames.DISCHARGE_TIME
  | SpecFieldNames.SPACING
  | SpecFieldNames.SLUMP
  | SpecFieldNames.SLUMP_TYPE
  | SpecFieldNames.ADDITIONAL_PRODUCTS
  | SpecFieldNames.LOAD_SIZE
  | SpecFieldNames.ADDITIONAL_INFO
  | SpecFieldNames.RECCURENCE
  | SpecFieldNames.PAYMENT_TERMS
  | SpecFieldNames.PAYMENT_TERMSDESC
  | SpecFieldNames.PAYMENT_TYPECODE
  | SpecFieldNames.ORDER_ID
  | SpecFieldNames.JOBSITE_CODE
  | SpecFieldNames.PLANTS
  | SpecFieldNames.FORMAT
  | SpecFieldNames.DELIVERY_MODE
  | SpecFieldNames.VEHICLE
  | SpecFieldNames.CATALOG
  | SpecFieldNames.PROTOTYPE_ADD
  | SpecFieldNames.STD_LOD_INFORMATIVE
  | SpecFieldNames.CEMEXPUMP_REQUIRED_SIZE
  | SpecFieldNames.CEMEXPUMP_ALTERNATIVE_SIZE_TO_MAXIMUM
  | SpecFieldNames.CEMEXPUMP_PIPE_LENGTH
  | SpecFieldNames.CEMEXPUMP_PIPE_DIAMETER
  | SpecFieldNames.CEMEXPUMP_COMMENTS
  | SpecFieldNames.CEMEXPUMP_POWER_LINE
  | SpecFieldNames.CEMEXPUMP_FALL_PROTECTION
  | SpecFieldNames.CEMEXPUMP_CLEANING_ON_SITE
  | SpecFieldNames.CEMEXPUMP_PRIMER_BY_CEMEX
  | SpecFieldNames.ITEM_SEQ_NUM
  | SpecFieldNames.PRODUCT_PUMP_INFORMATIVE
  | SpecFieldNames.CONCRETE_MIN_QUANTITY_INFO
  | SpecFieldNames.SAME_DAY_DELIVERY_MESSAGE
  | SpecFieldNames.MIN_WEIGHT_SURCHARGE_WARINING
  | SpecFieldNames.ID
  | SpecFieldNames.AFTER_CUTOFF_INFO;
